<div>
    @if (addingEditingMode === false) {
        <div>
            <!-- HEADER -->
            <div class="flex justify-content-between align-items-center gap-3 mb-3">
                <div class="flex align-items-center gap-2">
                    <h2 class="section-title m-0">{{ 'settings.analytical.title' | translate }}</h2>
                    <span
                        class="material-symbols-outlined icon-sm text-color-secondary cursor-help"
                        [pTooltip]="'settings.analytical.tooltip1' | translate"
                        >info</span
                    >
                </div>
                <p-button
                    [label]="'settings.analytical.addRow' | translate"
                    icon="ms ms-add"
                    (onClick)="addAnalyticalCategory()" />
            </div>
            <!-- TABLE -->
            <div class="card">
                <p-table
                    #dt
                    [value]="categories"
                    [paginator]="true"
                    [alwaysShowPaginator]="false"
                    [globalFilterFields]="['name', 'description', 'linkedEntities']"
                    [rows]="10">
                    <ng-template pTemplate="caption">
                        <p-iconfield>
                            <p-inputicon styleClass="ms ms-search" />
                            <input
                                type="text"
                                pInputText
                                [placeholder]="'settings.analytical.table.search' | translate"
                                [attr.aria-label]="'common.search' | translate"
                                (input)="dt.filterGlobal($any($event.target).value, 'contains')" />
                        </p-iconfield>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 30%" pSortableColumn="name">
                                {{ 'settings.analytical.table.name' | translate }}
                                <p-sortIcon field="name" />
                            </th>
                            <th style="width: 35%" pSortableColumn="description">
                                {{ 'settings.analytical.table.description' | translate }}
                                <p-sortIcon field="description" />
                            </th>
                            <th style="width: 35%">
                                {{ 'settings.analytical.table.linkedEntities' | translate }}
                            </th>
                            <th class="col-actions"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr [class.is-default]="rowData.default">
                            <td class="cell-truncate">
                                @if (rowData.default) {
                                    <span class="category-name">
                                        <span class="category-name__text">{{ rowData.name }}</span>
                                        <span
                                            class="material-symbols-outlined icon-sm category-name__lock"
                                            role="img"
                                            [attr.aria-label]="'settings.analytical.table.defaultTooltip' | translate"
                                            [pTooltip]="'settings.analytical.table.defaultTooltip' | translate"
                                            >lock</span
                                        >
                                    </span>
                                } @else {
                                    {{ rowData.name }}
                                }
                            </td>
                            <td class="cell-truncate">{{ rowData.description }}</td>
                            <td class="cell-truncate">
                                <div class="chip-list">
                                    @if (rowData.entities?.length > 0) {
                                        <!-- The first two entities, then one chip counting the others (listed in its tooltip) -->
                                        @for (entity of rowData.entities.slice(0, 2); track entity) {
                                            <p-chip [label]="entity.name" [pTooltip]="entity.name" />
                                        }
                                        @if (rowData.entities.length > 2) {
                                            <p-chip
                                                class="chip-list__more"
                                                [label]="'+' + (rowData.entities.length - 2)"
                                                [pTooltip]="getTooltipEntities(rowData.entities)"
                                                tooltipPosition="top" />
                                        }
                                    } @else {
                                        <p-chip [label]="'settings.analytical.table.allEntities' | translate" />
                                    }
                                </div>
                            </td>
                            <td class="col-actions">
                                @if (!rowData.default) {
                                    <p-button
                                        icon="ms ms-edit"
                                        [text]="true"
                                        [rounded]="true"
                                        size="small"
                                        [ariaLabel]="'components.settingsForm.button.edit' | translate"
                                        [pTooltip]="'components.settingsForm.button.edit' | translate"
                                        (onClick)="addAnalyticalCategory(rowData)" />
                                }
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="4">
                                <div class="empty-state empty-state--compact">{{ 'common.noData' | translate }}</div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    } @else {
        <app-edit-analytic-category
            (closeEditActivity)="onCloseEditActivity($event)"
            [organizationId]="organizationId"
            [selectedAnalyticCategory]="selectedAnalyticCategory"></app-edit-analytic-category>
    }
</div>
